module.exports = __webpack_public_path__ + "img/5.b3c4d61a.png";